
const NAYA_APP_BACKEND = "https://api.naya.studio/api/qaqc/new"

export {NAYA_APP_BACKEND}
